import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ELSGiftCardTransactions, GetGiftCardTransactionLogResponse, GetUserVoucherInstancesResponse, PreAuthenticationResponse, UserVoucherInstance } from '@picard/models-lib';
import { ApplicationService, BreadcrumbService, DashboardService } from '@picard/services-lib';
import moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { toDate } from '../history/history.component';
import { HostComponent } from 'src/app/layout/host/host.component';
import { StorageConstants } from '@picard/shared-lib';

export const dateFormats = {
  customDateTimeFormat: 'YYYY/MM/DD HH:mm:SS:SSS',
  customDateTimeFormat1: 'YYYY/MM/DD HH:mm:SS',
  seattleDateTimeFormat: 'ddd, DD MMM YYYY HH:mm',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
  dateOnlyFormat: 'DD/MM/YYYY',
  monthYearFormat: 'MM/YYYY',
  isoFormat: 'YYYY-MM-DD HH:mm:SS ' // Corresponds to '2016-01-04T13:00:00Z'
};

@Component({
  selector: 'app-voucher-history',
  templateUrl: './voucher-history.component.html',
  styleUrls: ['./voucher-history.component.css']
})
export class VoucherHistoryComponent implements OnInit {

  //#region Properties
  hasExpired: boolean = false;
  hasExpiryDate: boolean = false;
  voucherInstanceId: string;
  currentBalance: number = 0;
  loadedVouchersPanel: boolean;
  @BlockUI() blockUI: NgBlockUI;
  getUserVoucherInstancesResponse: GetUserVoucherInstancesResponse;
  voucherInstance: UserVoucherInstance;
  programId: number;
  preAuthenticationResponse: PreAuthenticationResponse;

  cols: any[];
  datasource: any[] = Array<any>();
  isMobile = false;
  getGiftCardTransactionLogResponse: GetGiftCardTransactionLogResponse;
  eLSGiftCardTransactions: ELSGiftCardTransactions[];
  userVoucherInstances: UserVoucherInstance[];
  //#endregion Properties

  constructor(private _breadcrumbService: BreadcrumbService, private _applicationService: ApplicationService, private _dashboardService: DashboardService, private route: ActivatedRoute, public hostComponent: HostComponent) {
    setInterval(() => {
      this.isMobile = hostComponent.isMobile();
    }, 2000); 
    this.programId = parseInt(sessionStorage.getItem('programID'));
    this.preAuthenticationResponse = JSON.parse(sessionStorage.getItem(StorageConstants.preAuth));
  }

  async ngOnInit() {
    this.route.params.subscribe(params => {
      this.voucherInstanceId = params['id'];
    });
    this._breadcrumbService.setItems([{ label: `Voucher/${this.voucherInstanceId}`, routerLink: `/vouchers/${this.voucherInstanceId}` }]);

    try{
      this.blockUI.start('Retrieving voucher history.');
      const userVoucherInstancesJson = sessionStorage.getItem("userVoucherInstances");
      if (userVoucherInstancesJson) {
        var uVoucherInstances : UserVoucherInstance[] = JSON.parse(userVoucherInstancesJson);
        this.userVoucherInstances = uVoucherInstances;
      }
      else{
        const getUserVoucherInstancesResponseInitialResponse: GetUserVoucherInstancesResponse = (this.getUserVoucherInstancesResponse = await this._dashboardService.GetUserVoucherInstancesAsync());
        this.userVoucherInstances = getUserVoucherInstancesResponseInitialResponse.voucherInstances;
        sessionStorage.setItem("userVoucherInstances", JSON.stringify(this.userVoucherInstances));
      }
        
        const vInstanceId: string = this.voucherInstanceId;
        this.voucherInstance = this.userVoucherInstances.filter(function(vi){
          return vi.voucherInstanceId.toString() == vInstanceId;
        })[0];
        
        if (this.voucherInstance.voucherStatusId == 3) 
        {
          this.currentBalance = this.voucherInstance.balance;
        }
        else{
          this.currentBalance = this.voucherInstance.balance;
        }
          
        
        const getGiftCardTransactionLogResponseInitialResponse: GetGiftCardTransactionLogResponse = (this.getGiftCardTransactionLogResponse = await this._dashboardService.GetGiftCardTransactionLogAsync(this.voucherInstance.voucherInstanceId));
          this.eLSGiftCardTransactions = getGiftCardTransactionLogResponseInitialResponse.elsGiftCardTransactions;
        this.blockUI.stop();
        this.loadedVouchersPanel = true;
        
        if (this.voucherInstance.expiryDateUtc !== '') this.hasExpiryDate = true;
        if (this.hasExpiryDate && this.voucherInstance.voucherStatusId == 4) this.hasExpired = true;

        if(this.eLSGiftCardTransactions != null){
          this.eLSGiftCardTransactions.forEach(x => {
            this.datasource.push({ date: moment.utc(x.date).local().format(dateFormats.seattleDateTimeFormat),
              description: x.description, 
              credit: x.credit, 
              debit: x.debit, 
              balance: x.balance,
              transactionType: x.transactionType, 
              partnerBranch: x.partnerBranch });
          });
        }
        
        //this.datasource.sort().reverse();
        this.cols = [{ field: 'date', header: 'Transaction Date' }, 
          { field: 'transactionType', header: 'Transaction' }, 
          { field: 'credit', header: 'Credit' }, 
          { field: 'debit', header: 'Debit' }, 
          { field: 'balance', header: 'Balance' },
          { field: 'partnerBranch', header: 'Store' },
          { field: 'description', header: 'Description' }];
    }catch (error) {
      this.loadedVouchersPanel = false;
      this.blockUI.stop();
      console.log(error);
    }
  }

  getFormattedDate(dateString: string){
    if (dateString == "") return dateString
    let date = new Date(dateString);
    return date.toDateString();
  }
  isDate(field: string): { valid: boolean; val: Date | null | moment.Moment | string } {
    const parameters = Array<string>();
    parameters.push(dateFormats.customDateTimeFormat);
    parameters.push(dateFormats.customDateTimeFormat1);
    const parse = toDate(field, parameters);
    return parse;
  }
  getStatus(voucherStatusId: number){
    let vStatus: string;
    switch(voucherStatusId){
      case 1:
        vStatus = 'Activated';
        break;
      case 2:
        vStatus = 'Issued';
        break;
      case 3:
        vStatus = 'Redeemed';
        break;
      case 4:
        vStatus = 'Expired';
        break;
      case 5:
        vStatus = 'Cancelled';
        break;
      case 6:
        vStatus = 'Suspended';
        break;
      case 7:
        vStatus = 'Hold';
        break;
      default:
        vStatus = 'Unknown';
    }
    return vStatus;
  }
}
